import React, {useState} from 'react';
import { Route, Switch } from 'react-router-dom';
import {AppContainer, LinksPageApp, useAppState} from '@nutastic/nutastic-react-app';
import ComingSoonPage from './pages/ComingSoonPage';
import Header from "./Header";

const App = () => {
    const { linksPageConfig } = useAppState();
    const [showLinksPage, setShowLinksPage] = useState(false);

    const onToggleLinksPageClick = () => setShowLinksPage(!showLinksPage);

    const renderPageRoute = () => {
        return <Switch>
            <Route path={['/', '/home']} render={() => <ComingSoonPage onToggleLinksPage={onToggleLinksPageClick} />} />
        </Switch>;
    };

    return <AppContainer>
        <Header onToggleLinksPage={onToggleLinksPageClick} linksPageIsActive={showLinksPage} />
        { renderPageRoute() }
        { (linksPageConfig && showLinksPage) && <LinksPageApp {...linksPageConfig} /> }
    </AppContainer>;
};

export default App;
